import { render } from "./DeletedHeadPhones.vue?vue&type=template&id=31b378ed&lang=html"
import script from "./DeletedHeadPhones.vue?vue&type=script&lang=js"
export * from "./DeletedHeadPhones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__